// auto-generated by {apiBaseUrl}/tools/typescriptmodels
export class DateSearchRange {
	public FromOnOrAfter?: Date;
	public ToOnOrBefore?: Date;
}